import { css, styled } from 'canoe';
import React from 'react';

import { HistoryActions } from './HistoryActions';
import { LayerSelection } from './LayerSelection';

export const FOOTER_HEIGHT = '32px';

const Container = styled.div`
  ${({ theme }) => css`
    height: ${FOOTER_HEIGHT};
    padding: 0;
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;

    background-color: ${theme.colors.GlitterGrayL10};
  `}
`;

export const Footer = () => (
  <Container>
    <LayerSelection />
    <HistoryActions />
  </Container>
);
